import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

// Drag-reorder for continuation shots in the scene modal's left rail.
// Primary shot is rendered OUTSIDE this controller's scope so it can't be
// dragged. On drop, collects the new clip_id order and PATCHes the reorder
// endpoint. Reloads on failure rather than optimistically reverting — page
// state after a failed reorder is easier to reason about with a fresh load.
export default class extends Controller {
  static targets = ["list"]
  static values = { url: String, sceneId: String }

  connect() {
    this.sortable = Sortable.create(this.listTarget, {
      handle: "[data-sort-handle]",
      animation: 150,
      ghostClass: "opacity-30",
      dragClass: "shadow-lg",
      onEnd: this.onDragEnd.bind(this)
    })
  }

  disconnect() {
    if (this.sortable) this.sortable.destroy()
  }

  async onDragEnd(event) {
    if (event.oldIndex === event.newIndex) return

    const items = this.listTarget.querySelectorAll("[data-clip-id]")
    const clipIds = Array.from(items).map((el) => el.dataset.clipId)
    const csrfToken = document.querySelector("meta[name='csrf-token']")?.content

    try {
      const response = await fetch(this.urlValue, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": csrfToken,
          Accept: "application/json"
        },
        body: JSON.stringify({
          scene_id: this.sceneIdValue,
          clip_ids: clipIds
        })
      })
      if (!response.ok) window.location.reload()
    } catch (_e) {
      window.location.reload()
    }
  }
}
